module.exports = "/assets/542049cdf568ae960a060bdce32931df.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GF.png
// module id = 1403
// module chunks = 0